import React from 'react';
import { motion } from 'framer-motion';
import { OfferCard } from './OfferCard';
export const FinalCTA = () => {
  return <section className="py-12 md:py-24 bg-navy-800 text-white relative overflow-hidden" data-id="element-64" data-mp="3udp1swq2twsn">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-vbred/20 via-navy-800 to-navy-800 pointer-events-none" data-id="element-65" data-mp="c7tvnlnquuuk" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-66" data-mp="m4ote2c70r7s">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display text-4xl md:text-6xl uppercase tracking-tight mb-6 md:mb-8" data-id="element-67" data-mp="h5vgab0tj285">
          Stop improvising <span className="text-vbred" data-id="element-68" data-mp="14vzhycug4rwi">every week.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-base md:text-xl text-gray-300 leading-relaxed mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-69" data-mp="zx4s4qy2a32w">
          Volleyball Ready Pro helps you prepare sessions in minutes, arrive at
          every practice more organized and coach with more professionalism.
          Less time in front of a blank page. More time doing what you love —
          coaching.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-70" data-mp="34ssivnpgnubj">
          <OfferCard compact={true} ctaText="🏐 YES — I WANT VOLLEYBALL READY PRO NOW" data-id="element-71" data-mp="3iu4vpq9brft7" />
        </motion.div>
      </div>
    </section>;
};